/**
 * Api specific utility to convert between snake_case and camelCase
 * we want camelCase all the places and the BE wants snake
 */
import camelCase from "lodash/fp/camelCase"; // lodash functional exports :o !
import snakeCase from "lodash/fp/snakeCase";
import {
  map,
  curry,
  fromPairs,
  adjust,
  toPairs,
  memoize,
  when,
  either,
  is,
  pipe,
  T,
  cond
} from "ramda";

const mapObjectKeys = curry((fn, obj) =>
  fromPairs(map(adjust(fn, 0), toPairs(obj)))
);

const camelize = mapObjectKeys(memoize(camelCase));
const snakeize = mapObjectKeys(memoize(snakeCase));

const arrayOfObjects = (elem) => is(Array)(elem) && typeof elem[0] === "object";

const arrayOfValues = (elem) => is(Array)(elem) && typeof elem[0] !== "object";

const conditionallyCaseBy = (method) =>
  cond([
    [arrayOfObjects, map(method)],
    [arrayOfValues, (x) => x],
    [is(Object), method],
    [T, (x) => x]
  ]);

const changeCase = (method) =>
  when(
    either(is(Array), is(Object)),
    pipe(
      conditionallyCaseBy(method),
      map((a) => changeCase(method)(a))
    )
  );

export const toSnakeCase = changeCase(snakeize);
export const toCamelCase = changeCase(camelize);
